export const useReservationPanel = () => {
  const isReservationPanelActive = useState('isReservationPanelActive', () => false);
  const activeSection = useState('activeSection', () => null);
  const SECTION_TYPES = ['accommodation', 'dates', 'guests', 'code']

  function openPanel(section) {
    isReservationPanelActive.value = true;
    if (section !== undefined) setActiveSection(section)
    document.documentElement.classList.add('isOverflow')
  }

  function setActiveSection(index: string) {
    activeSection.value = SECTION_TYPES[index]
  }

  function closePanel() {
    isReservationPanelActive.value = false
    setActiveSection(null)
    document.documentElement.classList.remove('isOverflow')
  }

  return {
    isReservationPanelActive,
    activeSection,
    SECTION_TYPES,

    openPanel,
    setActiveSection,
    closePanel,
  }
}